import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';

/**
 * English only for now (QZ-D8): no HTTP backend and no language detector.
 */
i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  // React already escapes rendered text; escaping here too would show `&#x2F;` in URLs.
  interpolation: { escapeValue: false },
  resources: {
    en: { translation: en },
  },
});

export default i18next;
